import { Component, OnInit, Inject } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { PageComponent, ModalService, ICC_PAGE_DATA } from '@icc/configurator/shared';
import { iccListItem, iccListTab } from '@icc/configurator/ui';
import { SharedFacade } from '@icc/configurator/shared';
import { TranslateService } from '@icc/shared';
import { ConstructColorDto as IccConstructColor } from '@icc/construction-elements/types';
import { CassonettoOptionsPageComponent } from '../cassonetto-options-page/cassonetto-options-page.component';
import { Cassonetto, ICCCassonetto} from '@icc/window-door/types';
import { IccColorGroup } from '@icc/construction-elements/types';
@Component({
    selector: 'icc-cassonettos-list-page',
    templateUrl: './cassonettos-list-page.component.html',
    styleUrls: ['./cassonettos-list-page.component.scss'],
    standalone: false
})
export class CassonettosListPageComponent extends PageComponent implements OnInit {
    public title = _('ACCESSORY|Kasonetki');
    public options = [];

    cassonettos: iccListItem[] = [];
    tabs: iccListTab[] = [];

    constructor(
        private sharedFacade: SharedFacade,
        private modalService: ModalService,
        private translateService: TranslateService,
        @Inject(ICC_PAGE_DATA)
        private pageData: {
            cassonettos: ICCCassonetto[];
            groups: any[];
            colors?: IccConstructColor[];
            colorGroups?: IccColorGroup[];
            productPricelists: any;
            noPrice: boolean;
        }
    ) {
        super();
    }

    ngOnInit() {
        this.cassonettos = this.pageData.cassonettos.map<iccListItem>(cassonetto => ({
            id: Number(cassonetto.id),
            title: cassonetto.name,
            imageUrl: `/files/cassonetto/${cassonetto.image}`,
            description: `${cassonetto.description}`,
            tabs: [Number(cassonetto.cassonettoGroupId)],
        }));
        this.tabs = this.pageData.groups.map<iccListTab>(group => ({
            id: Number(group.id),
            name: group.name,
        }));
    }

    selectCassonetto(item: iccListItem) {
        const cassonetto = this.pageData.cassonettos.find(a => Number(a.id) === Number(item.id));
        if (cassonetto) {
            this.modalService
                .open({
                    pageComponent: CassonettoOptionsPageComponent,
                    resolve: {
                        cassonettoData: cassonetto,
                        cassonetto: {} as Cassonetto,
                        colors: this.pageData.colors,
                        colorGroups: this.pageData.colorGroups || [],
                        productPricelists: this.pageData.productPricelists,
                    },
                })
                .result.then(result => {
                    this.sharedFacade.closePage(result);
                });
        }
    }
}
